import { render, staticRenderFns } from "./CPRO.vue?vue&type=template&id=308372e6&scoped=true"
import script from "./CPRO.vue?vue&type=script&lang=js"
export * from "./CPRO.vue?vue&type=script&lang=js"
import style0 from "./CPRO.vue?vue&type=style&index=0&id=308372e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308372e6",
  null
  
)

export default component.exports